@if (!isInEditMode) {
  <div class="re-bg-white re-w-full re-text re-flex re-p-20 re-pr-100 re-h-80 re-items-center re-relative
          md:re-w-600 md:re-mx-auto md:re-px-30
          lg:re-w-900">
    <div class="re-pt-3 bold md:re-text-base re-flex re-flex-col md:re-flex-row">
      <div>PLZ: {{postCode}}&nbsp;| {{consumption | number}}&nbsp;{{divisionId | divisionToUnit: 'billing'}}
      </div>
    </div>
    <button class="re-absolute re-right-0 re-top-0 re-w-80 re-h-80 re-primary re-button"
      [title]="'general.imgText.edit' | translate"
      data-qa="edit-desktop"
      (click)="onEdit()">
      <div class="re-h-30 re-w-30 re-mx-auto">
        <svg-icon src="{{ 'general.img.edit' | translate}}"></svg-icon>
      </div>
    </button>
  </div>
}

@if (isInEditMode) {
  <div class="re-bg-white re-w-full re-text re-flex re-p-20 re-flex-col
            md:re-w-600 md:re-mx-auto
            lg:re-w-900" animate.enter="bdo-fade-in">
    <div class="re-pt-3">{{ 'address.postCode.yourPostCode' | translate }} <span class="bold">{{ postCode }}</span></div>
  </div>
  <form bdoScrollToInvalidControl [bdoScrollToInvalidControlForm]="consumptionForm" [attr.aria-label]="'aria.form.consumptionSelection' | translate">
    @if (isChargeFlex) {
      <div
      class="re-bg-white re-w-full re-p-20 re-pb-10 re-text
        md:re-w-600 md:re-mx-auto
        re-border-monochrome-light re-border-solid re-border-t-3
        lg:re-w-900" animate.enter="bdo-fade-in">
        <div class="re-mt-45">
          <bdo-ecar-selection [parentForm]="consumptionForm"></bdo-ecar-selection>
          @if (getChargingConsumptionShown()) {
            <bdo-charging-consumption
              [parentForm]="consumptionForm"
            ></bdo-charging-consumption>
          }
        </div>
      </div>
    }
    @if (!isChargeFlex || (isChargeFlex && !chargeFlexHasOwnMeter)) {
      <div
      class="re-bg-white re-w-full re-p-20 re-pb-10 re-text
      md:re-w-600 md:re-mx-auto
      re-border-monochrome-light re-border-solid re-border-t-3
      lg:re-w-900" animate.enter="bdo-fade-in">
        <fieldset name="consumption-selection" class="md:re-mt-20 re-p-0">
          <div class="re-form-item-container re-mb-15">
            <fieldset name="household-size-selection" class="amount-container amount-container--persons re-mb-0" [formGroup]="consumptionForm">
              <ng-container>
                @if (isChargeFlex) {
                  <h4 class="bold re-mb-30">{{'tmh.consumption.house' | translate}}</h4>
                }
                <p class="re-text-sm re-leading-normal re-mb-5">
                  <span>{{ 'tariffAdvisor.consumption.title.' + divisionId | translate }}</span>
                </p>
                <div class="amount-grid-container">
                  @for (i of steps; track i) {
                    <div class="amount-container__item" >
                      <input type="radio" id="persons-{{i.step}}" name="rc-radio" value="{{i.step}}" [formControl]="$any(consumptionForm.controls.selectedStep)">
                      <label for="persons-{{i.step}}" class="re-leading-normal">{{i.step}}</label>
                    </div>
                  }
                </div>
              </ng-container>
            </fieldset>
          </div>
          <div class="re-form-item-container re-mb-30 re-pr-30 md:re-pr-0">
            <bdo-input labelText="{{ 'tariffAdvisor.consumption.yearlyConsumption' | translate: { unit: divisionId | divisionToUnit: 'billing' } }}"
              [formControl]="$any(consumptionForm.controls.consumption)"
              [help]="hasMultipleMeters ? ('tariffAdvisor.consumption.hintMultipleMeters' | translate) : ''"
            ></bdo-input>
          </div>
          @if (!isChargeFlex) {
            <button
              class="re-button re-relative re-primary re-border-none"
              data-qa="tariff-calculate-button"
              (click)="onCalculate()">
              <span>{{ 'tariffAdvisor.consumption.calculate' | translate }}</span>
            </button>
          }
        </fieldset>
      </div>
    }
    @if (isChargeFlex && !chargeFlexHasOwnMeter && getChargingConsumptionShown()) {
      <div
        class="re-bdo-tile re-mt-5 md:re-text-m md:re-leading-m">
        <div class="re-tariff-row bold">
          <div>{{'tmh.consumption.overall' | translate}}</div>
          <div>{{getOverallConsumption()}} kWh</div>
        </div>
      </div>
    }
    @if (isChargeFlex) {
      <button
        type="submit"
        class="re-button re-relative re-primary re-border-none re-mt-20"
        data-qa="tariff-calculate-button"
        (click)="onCalculate()">
        <span>{{ 'tariffAdvisor.consumption.calculate' | translate }}</span>
      </button>
    }
  </form>
}
